<template>
	<div>
	<ppe-form 
		entityName="Document"
	    formkey="b1_eu"
		:title="'Identité - '+values['Company.Name']"
		title-field=""
 	    sub-title="Renseignez les informations"
		:schema="schema" 
        :endpoint="endpoint"
		v-on:dataLoaded="onDataLoaded"

		>

	</ppe-form>
	</div>
</template>
<script>
import Utils    from '../ppe/utils'
 

export default {
	

	data() {
		return {
			values: {},
			endpoint : this.getApiUrl(),
			schema : [ 
				{
					card: "Fiche signalétique de l’ENTITE SUPPORT", cardkey:"card_headquarter", 
					body:[
						{name:"Company.Headquarters.Name",       label:"Nom ENTITE SUPPORT",     type: "text",     validation: 'required', size:'large', help:"Nom de l'entité support, peut être différent du nom de l'entité évaluée"},
						
						{name:"Company.Address.Street",    label:"Adresse", type: "text", validation: 'required', size:'large'},
						{name:"Company.Address.Street2",    label:"Complément", type: "text", validation: '', size:'large'},

						{name:"Company.Address.Postalcode",        label:"Code postal",             type: "number",   validation: 'required', size:'small'},
						{name:"Company.Address.City",       label:"Ville",                   type: "text",     validation: 'required'},



                        /*
						{name:"activity",   label:"Activité principale",     type: "text",     validation: 'required'},
						{name:"activity2",  label:"Activité secondaire", 		 type: "text",     validation: ''},

						{name:"siret",   		label:"SIRET",                type: "text",     validation: 'required', size:'small'},
						{name:"ape",   			label:"Code APE",                type: "text",     validation: 'required', size:'small'},
						//{name:"statut",     label:"Statut (SA, SAS, SARL, ..)", type: "text",  validation: 'required', size:'small'},
						//{name:"nbentities", label:"Nombre d'entités", 			 type: "number",   validation: '',         size:'small'},
						{name:"nbemployees",label:"Nombre de personnels",type: "number",  placeholder: 'Nombre',         size:'small'},
						
						{name:"website",    label:"Site web",                type: "text",     validation: '', size:'large'},
						//{component:"div",   },

						{name:"companyOwner.name",   label:"Responsable de l'entité utilisatrice",  type: "text",   validation: 'required',   size: 'Medium'},
						{name:"companyOwner.phone",   label:"Portable",  type: "text",       validation: 'required',  size: 'small'},
						{name:"companyOwner.email",   label:"Email",  type: "text",          validation: 'required',  size: 'small'},
						
						{name:"securityOfficer.name",   label:"Responsable sécurité",  type: "text",     size: 'Medium'},
						{name:"securityOfficer.phone",   label:"Portable",  type: "text",     size: 'small'},
						{name:"securityOfficer.email",   label:"Email",  type: "text",     size: 'small'},

						{name:"covidOfficer.name",   label:"Responsable COVID 19",  type: "text",     size: 'Medium'},
						{name:"covidOfficer.phone",   label:"Portable",  type: "text",     size: 'small'},
						{name:"covidOfficer.email",   label:"Email",  type: "text",     size: 'small'},

						{name:"operationOfficer.name",   label:"Responsable des opérations",  type: "text",     validation: 'required',   size: 'Medium'},
						{name:"operationOfficer.phone",   label:"Portable",  type: "text",     validation: 'required',   size: 'small'},
						{name:"operationOfficer.email",   label:"Email",  type: "text",     validation: 'required',   size: 'small'},*/
					]
				},
				
				Utils.getGetManagerCard(),

				Utils.getAdminCard(),

				],

		}
	},

	methods : {
		getDocumentId() {
			let documentId  = this.$route.params.id
			return documentId
		},
		getApiUrl() {
			return "/du/document?id="+this.getDocumentId()
		},
		onDataLoaded(data) {
			this.values = data.entity
            console.log("onDataLoaded", data.entity['Company.Name'])
            this.$eventbus.$emit("on-title", data.entity['Company.Name'])
		}
	}

};
</script>
<style>
</style>
 